import React from 'react';
import { Link } from 'react-router-dom';
import { LinkedinIcon, TwitterIcon, MailIcon, MapPinIcon, PhoneIcon } from 'lucide-react';
export function Footer() {
  const links = {
    services: [{
      label: 'Global Product Sourcing',
      path: '/services'
    }, {
      label: 'Tender Support',
      path: '/services'
    }, {
      label: 'Supplier Verification',
      path: '/services'
    }, {
      label: 'Contract Liaison',
      path: '/services'
    }, {
      label: 'Logistics Coordination',
      path: '/services'
    }, {
      label: 'Market Research',
      path: '/services'
    }],
    company: [{
      label: 'About Us',
      path: '/about'
    }, {
      label: 'Our Process',
      path: '/'
    }, {
      label: 'Sectors',
      path: '/sectors'
    }, {
      label: 'Contact',
      path: '/contact'
    }],
    resources: [{
      label: 'Supplier Registration',
      path: '/supplier-registration'
    }, {
      label: 'FAQ',
      path: '/faq'
    }, {
      label: 'Global Presence',
      path: '/'
    }, {
      label: 'Capability Highlights',
      path: '/'
    }]
  };
  return <footer className="bg-navy-dark border-t border-slate-800 pt-16 pb-8 px-6" data-id="element-79">
      <div className="max-w-7xl mx-auto" data-id="element-80">
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-12 mb-12" data-id="element-81">
          {/* Brand Column */}
          <div className="lg:col-span-2" data-id="element-82">
            <Link to="/" className="flex items-center gap-3 mb-4" data-id="element-83">
              <div className="w-12 h-12 bg-gold rounded-md flex items-center justify-center" data-id="element-84">
                <span className="text-navy-dark text-xl font-bold" data-id="element-85">888</span>
              </div>
              <div className="flex flex-col leading-tight" data-id="element-86">
                <span className="text-white text-sm font-semibold tracking-wide" data-id="element-87">
                  SOURCING
                </span>
                <span className="text-white text-sm font-semibold tracking-wide" data-id="element-88">
                  LIMITED
                </span>
              </div>
            </Link>
            <p className="text-slate-400 text-sm leading-relaxed mb-6 max-w-sm" data-id="element-89">
              UK-based independent procurement consultancy connecting global
              suppliers with institutional and commercial procurement
              opportunities worldwide, with a flagship focus on Africa and
              high-growth emerging markets.
            </p>
            <div className="flex items-start gap-2 text-slate-400 text-sm mb-2" data-id="element-90">
              <MapPinIcon size={16} className="text-gold flex-shrink-0 mt-0.5" data-id="element-91" />
              <span data-id="element-92">
                Vermeulens Garden Centre, Horton Road,
                <br data-id="element-93" />
                Staines-upon-Thames, Middlesex TW19 6AE,
                <br data-id="element-94" />
                United Kingdom
              </span>
            </div>
            <div className="flex items-center gap-2 text-slate-400 text-sm mb-2 mt-3" data-id="element-95">
              <MailIcon size={16} className="text-gold flex-shrink-0" data-id="element-96" />
              <a href="mailto:info@888sourcing.co.uk" className="hover:text-gold transition-colors" data-id="element-97">
                info@888sourcing.co.uk
              </a>
            </div>
            <div className="flex items-center gap-2 text-slate-400 text-sm mb-2" data-id="element-98">
              <PhoneIcon size={16} className="text-gold flex-shrink-0" data-id="element-99" />
              <a href="tel:+443330579291" className="hover:text-gold transition-colors" data-id="element-100">
                +44 333 057 9291
              </a>
            </div>
            <div className="text-slate-500 text-xs mt-4" data-id="element-101">
              Company No. 08400329 | VAT GB158689350
            </div>
          </div>

          {/* Services */}
          <div data-id="element-102">
            <h3 className="text-white font-semibold mb-4" data-id="element-103">Services</h3>
            <ul className="space-y-2" data-id="element-104">
              {links.services.map(link => <li key={link.label} data-id="element-105">
                  <Link to={link.path} className="text-slate-400 hover:text-gold text-sm transition-colors" data-id="element-106">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* Company */}
          <div data-id="element-107">
            <h3 className="text-white font-semibold mb-4" data-id="element-108">Company</h3>
            <ul className="space-y-2" data-id="element-109">
              {links.company.map(link => <li key={link.label} data-id="element-110">
                  <Link to={link.path} className="text-slate-400 hover:text-gold text-sm transition-colors" data-id="element-111">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* Resources */}
          <div data-id="element-112">
            <h3 className="text-white font-semibold mb-4" data-id="element-113">Resources</h3>
            <ul className="space-y-2" data-id="element-114">
              {links.resources.map(link => <li key={link.label} data-id="element-115">
                  <Link to={link.path} className="text-slate-400 hover:text-gold text-sm transition-colors" data-id="element-116">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-117">
          <div className="flex flex-col md:flex-row md:items-center gap-2 md:gap-6" data-id="element-118">
            <p className="text-slate-500 text-sm" data-id="element-119">
              © {new Date().getFullYear()} 888 Sourcing Limited. All rights
              reserved.
            </p>
            <div className="flex items-center gap-4" data-id="element-120">
              <Link to="/privacy-policy" className="text-slate-500 hover:text-gold text-sm transition-colors" data-id="element-121">
                Privacy Policy
              </Link>
              <Link to="/terms" className="text-slate-500 hover:text-gold text-sm transition-colors" data-id="element-122">
                Terms
              </Link>
            </div>
          </div>

          <div className="flex items-center gap-6" data-id="element-123">
            <a href="#" className="text-slate-400 hover:text-gold transition-colors" aria-label="LinkedIn" data-id="element-124">
              <LinkedinIcon size={20} data-id="element-125" />
            </a>
            <a href="#" className="text-slate-400 hover:text-gold transition-colors" aria-label="Twitter" data-id="element-126">
              <TwitterIcon size={20} data-id="element-127" />
            </a>
          </div>
        </div>
      </div>
    </footer>;
}